import { render, staticRenderFns } from "./TechnicalSupportForm.vue?vue&type=template&id=557ab16e&"
import script from "./TechnicalSupportForm.vue?vue&type=script&lang=js&"
export * from "./TechnicalSupportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports